export interface BrandFrontendConfig {
  id: string;
  metaTitle: string;
  logoUrl: string;
  logoIconUrl?: string;
  faviconUrl: string;
  cssVars: Partial<{
    '--background-accent': string;
    '--background-accent-disabled': string;
    '--body-accent': string;
    '--border-general-accent': string;
    '--icon-general-accent': string;
    '--status-test': string;
    '--chips-status-status-test': string;
  }>;
  hasOrientation?: boolean;
}

const brands: BrandFrontendConfig[] = [
  {
    // Testbusters
    id: '607fe6f7879db1c48df247b4',
    metaTitle: 'Simulatore Testbusters',
    logoUrl: '/logo/testbusters-full.svg',
    logoIconUrl: '/logo/testbusters.svg',
    faviconUrl: '/favicons/favicon-testbusters.ico',
    cssVars: {
      '--background-accent': '#ff3300',
      '--background-accent-disabled': '#fff5f2',
      '--body-accent': '#ff3300',
      '--border-general-accent': '#ff3300',
      '--icon-general-accent': '#ff3300',
      '--status-test': '#ff3300',
      '--chips-status-status-test': '#fff5f2',
    },
    hasOrientation: true,
  },
  {
    // Peer4Med
    id: '60acfd593ad3392d9e5a164d',
    metaTitle: 'Simulatore Peer4Med',
    logoUrl: '/logo/peer4med-full.svg',
    logoIconUrl: '/logo/peer4med.png',
    faviconUrl: '/favicons/favicon-peer4med.ico',
    cssVars: {
      '--background-accent': '#e270ab',
      '--background-accent-disabled': '#DFECF2',
      '--body-accent': '#ff3300',
      '--border-general-accent': '#ff3300',
      '--icon-general-accent': '#ff3300',
      '--status-test': '#ff3300',
      '--chips-status-status-test': '#fff5f2',
    },
    hasOrientation: false,
  },
  {
    // Medschool
    id: '69e23d5b5e2908ed75318dcc',
    metaTitle: 'Simulatore Medschool',
    logoUrl: '/logo/medschool-full.svg',
    faviconUrl: '/favicons/favicon-medschool.ico',
    cssVars: {
      '--background-accent': '#9a1a60',
      '--background-accent-disabled': '#F5E8EF',
      '--body-accent': '#ff3300',
      '--border-general-accent': '#ff3300',
      '--icon-general-accent': '#ff3300',
      '--status-test': '#ff3300',
      '--chips-status-status-test': '#fff5f2',
    },
    hasOrientation: false,
  },
  {
    // TopSquad
    id: '69e23d5b5e2908ed75318dcd',
    metaTitle: 'Simulatore TopSquad',
    logoUrl: '/logo/topsquad-full.svg',
    faviconUrl: '/favicons/favicon-topsquad.ico',
    cssVars: {
      '--background-accent': '#284baa',
      '--background-accent-disabled': '#DAE1F5',
      '--body-accent': '#ff3300',
      '--border-general-accent': '#ff3300',
      '--icon-general-accent': '#ff3300',
      '--status-test': '#ff3300',
      '--chips-status-status-test': '#fff5f2',
    },
    hasOrientation: false,
  },
];

const DEFAULT_BRAND: BrandFrontendConfig = brands[0];

export function getBrandConfig(brandId?: string): BrandFrontendConfig {
  if (!brandId) return DEFAULT_BRAND;
  return brands.find((b) => b.id === brandId) ?? DEFAULT_BRAND;
}
